import React from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import SignaturePadComponent, {
  SignaturePadRef,
} from "./SignaturePadComponent";

interface SignaturesProps {
  additionalTeamMembers: any[];
  formValues: any;
  setFormValues: any;
  firstRef: React.RefObject<SignaturePadRef>;
  secondRef: React.RefObject<SignaturePadRef>;
  additionalMemberRefs: React.RefObject<SignaturePadRef>[];
}

const Signatures: React.FC<SignaturesProps> = ({
  additionalTeamMembers,
  formValues,
  setFormValues,
  firstRef,
  secondRef,
  additionalMemberRefs,
}) => {
  // Memoize the component to prevent unnecessary re-renders
  const memoizedMembers = React.useMemo(
    () => additionalTeamMembers,
    [additionalTeamMembers]
  );

  return (
    <div className="tw-w-full tw-mt-6">
      <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-gap-4 sm:tw-gap-6 tw-w-full">
        {/* Team Member 1 Signature */}
        <div className="tw-flex tw-flex-col tw-items-start tw-w-full">
          <span className="tw-mb-2 tw-mt-4 tw-text-sm sm:tw-text-base tw-font-medium">
            {formValues?.teamMember1?.displayName || "Team Member 1"}
          </span>
          <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
            <div className="tw-w-full tw-min-h-[120px] sm:tw-min- tw-border tw-border-gray-300 tw-rounded">
              <SignaturePadComponent
                ref={firstRef}
                penColor="black"
                // className="tw-w-full tw-h-full"
                onEnd={() => {
                  setFormValues((prev: any) => ({
                    ...prev,
                    teamMember1: {
                      ...prev.teamMember1,
                      signatureDate: new Date().toISOString(),
                    },
                  }));
                }}
              />
            </div>
            <Button
              label="Clear"
              onClick={() => firstRef.current?.clear()}
              className="tw-mt-2 focus:tw-shadow-none tw-bg-[#152846] tw-text-white tw-px-3 sm:tw-px-4 tw-py-1 sm:tw-py-2 tw-rounded-full tw-text-xs sm:tw-text-sm"
            />
          </div>
        </div>

        {/* Team Member 2 Signature */}
        {formValues?.teamMember2?.userID && (
          <div className="tw-flex tw-flex-col tw-items-start tw-w-full">
            <span className="tw-mb-2 tw-mt-4 tw-text-sm sm:tw-text-base tw-font-medium">
              {formValues?.teamMember2?.displayName || "Team Member 2"}
            </span>
            <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
              <div className="tw-w-full tw-min-h-[120px] sm:tw-m tw-border tw-border-gray-300 tw-rounded">
                <SignaturePadComponent
                  ref={secondRef}
                  penColor="black"
                  // className="tw-w-full tw-h-full"
                  onEnd={() => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      teamMember2: {
                        ...prev.teamMember2,
                        signatureDate: new Date().toISOString(),
                      },
                    }));
                  }}
                />
              </div>
              <Button
                label="Clear"
                onClick={() => secondRef.current?.clear()}
                className="tw-mt-2 focus:tw-shadow-none tw-bg-[#152846] tw-text-white tw-px-3 sm:tw-px-4 tw-py-1 sm:tw-py-2 tw-rounded-full tw-text-xs sm:tw-text-sm"
              />
            </div>
          </div>
        )}

        {/* Additional Team Members Signatures */}
        {memoizedMembers.map((member, index) => (
          <div
            key={member.userID}
            className="tw-flex tw-flex-col tw-items-start tw-w-full"
          >
            <span className="tw-mb-2 tw-mt-4 tw-text-sm sm:tw-text-base tw-font-medium">
              {member.displayName}
            </span>
            <div className="tw-flex tw-flex-col tw-items-end tw-w-full tw-justify-end">
              <div className="tw-w-full tw-min-h-[120px] tw-border tw-border-gray-300 tw-rounded">
                <SignaturePadComponent
                  ref={additionalMemberRefs[index]}
                  penColor="black"
                  // className="tw-w-full tw-h-full"
                  onEnd={() => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      additionalTeamMembers: prev.additionalTeamMembers.map(
                        (tm: any, i: number) =>
                          i === index
                            ? { ...tm, signatureDate: new Date().toISOString() }
                            : tm
                      ),
                    }));
                  }}
                />
              </div>
              <Button
                label="Clear"
                onClick={() => additionalMemberRefs[index]?.current?.clear()}
                className="tw-mt-2 focus:tw-shadow-none tw-bg-[#152846] tw-text-white tw-px-3 sm:tw-px-4 tw-py-1 sm:tw-py-2 tw-rounded-full tw-text-xs sm:tw-text-sm"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default React.memo(Signatures);
